export default __webpack_public_path__ + "static/media/greyFilledEllipsis.869d818f.svg";